package com.nonopn.skydome.common.app.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.keraunic.KeraunicReportScreen
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_keraunic_report
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavTypeWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterParameters
import kotlinx.serialization.Serializable
import kotlin.reflect.KType

@Serializable
data class RouteKeraunicReport(
    val projectUuid: String,
    val projectName: String,
    val lat: Double,
    val lon: Double,
) : RouteParameterTo

object RouterKeraunicReport : RouterParameters<RouteKeraunicReport>(RouteKeraunicReport::class) {
    override val typeMap: Map<KType, NavTypeWrapper<Any>> get() = emptyMap()

    override fun routeFrom(parameters: RouteKeraunicReport) =
        "/report/keraunic/${parameters.projectUuid}"

    @Composable
    override fun Show(parameters: RouteKeraunicReport) {
        RouteKeraunicReportImpl(parameters).scene()
    }

    override fun navigateTo(instance: RouteKeraunicReport) = NavigateTo(
        route = instance,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        routeParameterTo is RouteKeraunicReport

    override fun isMatching(route: String) = route.startsWith("/report/keraunic/")

    override fun navigateFrom(path: String): RouteKeraunicReport = TODO()
}

class RouteKeraunicReportImpl(params: RouteKeraunicReport) : Route<RouteKeraunicReport>(
    route = "/report/keraunic/${params.projectUuid}",
    params = params,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) { onEntryIsActive(appModel) }

        val project = remember {
            Project(
                latitude = params.lat,
                longitude = params.lon,
                name = params.projectName,
                uuid = params.projectUuid
            )
        }

        KeraunicReportScreen(project = project, appModel = appModel)
    }

    private fun onEntryIsActive(appModel: AppModel) {
        appModel.setAppBarState(
            AppBarState.Localized(title = Res.string.menu_keraunic_report, emptyList<MenuItem>())
        )
    }
}
